import { Shield, Clock } from "lucide-react";

export const AboutSection = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-16 md:py-24 bg-secondary relative"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://images.pexels.com/photos/7736043/pexels-photo-7736043.jpeg"
                alt="Friendly insurance agent"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-accent/20 rounded-2xl -z-10" />
            <div className="absolute -top-6 -left-6 w-24 h-24 bg-primary/10 rounded-2xl -z-10" />
          </div>

          {/* Content */}
          <div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground mb-6">
              Insurance That Feels Like Family
            </h2>
            <p className="text-base md:text-lg text-muted-foreground mb-6">
              At Palmetto South Insurance Group, we believe insurance should be
              simple, affordable, and personal. As a locally-owned agency, we take
              pride in knowing our clients by name and treating every policy like
              our own.
            </p>
            <p className="text-base text-muted-foreground mb-8">
              Our team of licensed agents works with top-rated carriers to find
              you the best coverage at the best price. Whether you're a first-time
              homebuyer, a new driver, or planning for your family's future, we're
              here to guide you every step of the way.
            </p>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 gap-6">
              <div data-testid="about-stat-0" className="text-center">
                <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 mb-3">
                  <Shield className="h-5 w-5 text-primary" />
                </div>
                <div className="font-heading text-2xl font-bold text-foreground">10+</div>
                <div className="text-sm text-muted-foreground">Years Experience</div>
              </div>
              <div data-testid="about-stat-1" className="text-center">
                <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 mb-3">
                  <Clock className="h-5 w-5 text-primary" />
                </div>
                <div className="font-heading text-2xl font-bold text-foreground">24/7</div>
                <div className="text-sm text-muted-foreground">Claims Support</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
